(() => {
  "use strict";

  const offer = document.querySelector("[data-fk-offer]");
  if (!offer) return;

  const form = document.querySelector("#fk-product-form");
  const quantity = document.querySelector("#fk-quantity");
  const total = document.querySelector("#fk-total");
  const stickyPrice = document.querySelector("#fk-sticky-price");
  const stickyContext = document.querySelector("[data-sticky-context]");
  const stickyBase = document.querySelector("[data-sticky-base]");
  const twoKitTotal = document.querySelector("#fk-two-kit-total");
  const twoKitBase = document.querySelector("[data-two-kit-base]");
  const twoKitLabel = document.querySelector("[data-two-kit-label]");
  const twoKitDelivery = document.querySelector("[data-two-kit-delivery]");
  const welcomeOffer = offer.querySelector("[data-welcome-offer]");
  const welcomeAfter = welcomeOffer?.querySelector("[data-welcome-after]");
  const welcomeQuantity = welcomeOffer?.querySelector("[data-welcome-quantity]");
  const welcomeTotalLabel = welcomeOffer?.querySelector("[data-welcome-total-label]");
  const baseTotalLabel = welcomeOffer?.querySelector("[data-base-total-label]");
  const basePriceRow = welcomeOffer?.querySelector("[data-base-price-row]");
  const deliveryEstimate = welcomeOffer?.querySelector("[data-delivery-estimate]");
  const welcomeTerms = welcomeOffer?.querySelector("[data-welcome-terms]");
  const returnTarget = form.querySelector("[data-return-target]");
  const cartTarget = returnTarget.dataset.cartTarget || "/cart";
  const checkoutTarget = returnTarget.dataset.checkoutTarget || "/checkout";
  const discountPath = returnTarget.dataset.discountPath || `${window.location.origin}/discount/WELCOME15`;
  const unitPriceCents = Number(offer.dataset.unitPrice);
  const pricePresentation = window.FullyKitted?.pricePresentation;
  const unitPriceLabel = offer.dataset.unitLabel;
  const maxQuantity = Number(offer.dataset.maxQuantity) || 9;
  const currencyIso = offer.dataset.currency || "ZAR";
  const supportsWelcomeEstimate = currencyIso === "ZAR" && offer.dataset.physical === "true";
  const money = (cents) => {
    if (currencyIso === "ZAR" && pricePresentation?.formatZar) return pricePresentation.formatZar(cents) || "";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: currencyIso }).format(Number(cents) / 100);
    } catch {
      return "";
    }
  };

  const query = new URLSearchParams(window.location.search);
  const requestedVariant = query.get("variant");
  const requestedQuantity = Number(query.get("quantity"));
  const variantInput = form.querySelector('input[name="id"]');
  const activeVariantId = variantInput?.value;
  const variantAvailable = variantInput?.dataset.available === "true";
  const queryVariantValid = variantAvailable && (!requestedVariant || requestedVariant === activeVariantId);
  const initialQuantity = Number.isSafeInteger(requestedQuantity) && requestedQuantity >= 1 && queryVariantValid ? requestedQuantity : NaN;
  if (Number.isSafeInteger(initialQuantity) && initialQuantity >= 1) quantity.value = String(Math.min(maxQuantity, initialQuantity));

  function discountReturnTo(destination) {
    const target = new URL(destination, window.location.origin);
    return `${discountPath}?redirect=${encodeURIComponent(`${target.pathname}${target.search}`)}`;
  }

  function selectedQuantity() {
    const parsed = Number.parseInt(quantity.value, 10);
    return Number.isFinite(parsed) ? Math.min(maxQuantity, Math.max(1, parsed)) : 1;
  }

  function refreshTotals() {
    const count = selectedQuantity();
    quantity.value = String(count);
    const estimate = supportsWelcomeEstimate
      ? (pricePresentation?.discountedTotal(unitPriceCents, count, 15) ?? Math.round(unitPriceCents * count * 0.85))
      : unitPriceCents * count;
    total.textContent = money(estimate);
    if (welcomeAfter) welcomeAfter.textContent = money(estimate);
    if (welcomeTotalLabel) welcomeTotalLabel.hidden = !supportsWelcomeEstimate;
    if (baseTotalLabel) baseTotalLabel.hidden = supportsWelcomeEstimate;
    if (welcomeQuantity) {
      welcomeQuantity.hidden = !supportsWelcomeEstimate;
      welcomeQuantity.textContent = `${welcomeQuantity.dataset.welcomeLabel || "With WELCOME15 · if eligible"} · ${count} ${count === 1 ? "kit" : "kits"}`;
    }
    if (basePriceRow) basePriceRow.hidden = !supportsWelcomeEstimate;
    if (deliveryEstimate) deliveryEstimate.hidden = !supportsWelcomeEstimate;
    if (welcomeTerms) welcomeTerms.hidden = !supportsWelcomeEstimate;
    if (twoKitLabel) twoKitLabel.hidden = !supportsWelcomeEstimate;
    if (twoKitDelivery) twoKitDelivery.hidden = !supportsWelcomeEstimate;
    stickyPrice.textContent = money(estimate);
    if (stickyContext) stickyContext.hidden = !supportsWelcomeEstimate;
    if (stickyBase) stickyBase.hidden = supportsWelcomeEstimate;
    twoKitTotal.textContent = money(supportsWelcomeEstimate
      ? (pricePresentation?.discountedTotal(unitPriceCents, 2, 15) ?? Math.round(unitPriceCents * 2 * 0.85))
      : unitPriceCents * 2);
    if (twoKitBase) twoKitBase.textContent = unitPriceLabel;
  }

  document.querySelectorAll("[data-quantity]").forEach((button) => {
    button.addEventListener("click", () => {
      const direction = button.dataset.quantity === "plus" ? 1 : -1;
      quantity.value = String(Math.min(maxQuantity, Math.max(1, selectedQuantity() + direction)));
      refreshTotals();
    });
  });
  quantity.addEventListener("input", refreshTotals);
  quantity.addEventListener("change", refreshTotals);

  const heroImage = document.querySelector("#fk-hero-image");
  const zoomImage = document.querySelector("#fk-zoom-image");
  const galleryPosition = document.querySelector("#fk-gallery-position");
  const thumbnails = [...document.querySelectorAll(".thumb[data-image]")];
  const zoomDialog = document.querySelector("#fk-zoom-dialog");
  const zoomButton = document.querySelector("#fk-zoom-button");
  let zoomReturnFocus = null;

  thumbnails.forEach((button, index) => {
    button.addEventListener("click", () => {
      thumbnails.forEach((thumb) => thumb.setAttribute("aria-pressed", String(thumb === button)));
      heroImage.src = button.dataset.image;
      heroImage.alt = button.dataset.alt;
      zoomImage.src = button.dataset.image;
      zoomImage.alt = button.dataset.alt;
      galleryPosition.textContent = `${String(index + 1).padStart(2, "0")} / ${String(thumbnails.length).padStart(2, "0")} · ${galleryPosition.dataset.selectLabel || "Select an image"}`;
    });
  });
  zoomButton.addEventListener("click", () => {
    zoomReturnFocus = zoomButton;
    zoomImage.src = heroImage.currentSrc || heroImage.src;
    zoomImage.alt = heroImage.alt;
    zoomDialog.showModal();
  });

  function bindDialog(dialog) {
    if (!dialog) return;
    let returnFocus = null;
    dialog.querySelectorAll("[data-close-modal]").forEach((button) => button.addEventListener("click", () => dialog.close()));
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("close", () => {
      if (returnFocus?.isConnected) returnFocus.focus();
    });
    dialog.addEventListener("cancel", () => { returnFocus = dialog.returnFocusElement; });
    dialog.openFrom = (trigger) => {
      returnFocus = trigger;
      dialog.returnFocusElement = trigger;
      dialog.showModal();
      dialog.querySelector("[data-close-modal]")?.focus();
    };
  }

  [zoomDialog, document.querySelector("#fk-review-dialog"), document.querySelector("#fk-help-dialog")].forEach(bindDialog);
  zoomDialog.addEventListener("close", () => {
    if (zoomReturnFocus?.isConnected) zoomReturnFocus.focus();
  });

  const helpDialog = document.querySelector("#fk-help-dialog");
  document.querySelectorAll("[data-open-help]").forEach((button) => button.addEventListener("click", () => helpDialog.openFrom(button)));

  const reviewDialog = document.querySelector("#fk-review-dialog");
  const reviewPlayer = document.querySelector("#fk-review-player");
  const reviewName = document.querySelector("#fk-review-name");
  const reviewError = document.querySelector("#fk-review-error");
  const directLink = document.querySelector("[data-review-direct-link]");
  let activeReviewSource = "";
  document.querySelectorAll("[data-review-src]").forEach((button) => {
    button.addEventListener("click", () => {
      activeReviewSource = button.dataset.reviewSrc;
      reviewName.textContent = `${button.dataset.reviewName} · Video review`;
      directLink.href = activeReviewSource;
      reviewError.hidden = true;
      reviewDialog.openFrom(button);
      reviewPlayer.src = activeReviewSource;
      reviewPlayer.load();
    });
  });
  reviewPlayer.addEventListener("error", () => {
    if (reviewDialog.open && activeReviewSource) reviewError.hidden = false;
  });
  reviewDialog.addEventListener("close", () => {
    reviewPlayer.pause();
    reviewPlayer.removeAttribute("src");
    reviewPlayer.load();
    directLink.removeAttribute("href");
    reviewError.hidden = true;
    activeReviewSource = "";
  });

  document.querySelectorAll("[data-scroll-buy]").forEach((button) => button.addEventListener("click", () => {
    document.querySelector("#buy").scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  }));
  document.querySelector("[data-two-kits]")?.addEventListener("click", () => {
    quantity.value = "2";
    refreshTotals();
    form.requestSubmit(form.querySelector("[data-add-button]"));
  });

  const addButtons = [...document.querySelectorAll("[data-add-button]")];
  addButtons.forEach((button) => { button.dataset.originalLabel = button.textContent.trim(); });
  form.addEventListener("submit", (event) => {
    const isBuyNow = event.submitter?.hasAttribute("data-buy-now") === true;
    returnTarget.value = discountReturnTo(isBuyNow ? checkoutTarget : cartTarget);
    if (!isBuyNow) {
      addButtons.forEach((button) => {
        button.disabled = true;
        button.textContent = button.dataset.addingText;
      });
    }
  });
  window.addEventListener("pageshow", () => {
    returnTarget.value = discountReturnTo(cartTarget);
    addButtons.forEach((button) => {
      button.disabled = false;
      button.textContent = button.dataset.originalLabel;
    });
  });

  const sticky = document.querySelector("[data-sticky-buy]");
  const buyArea = document.querySelector("[data-fk-buy]");
  if (sticky && buyArea && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle("visible", !entry.isIntersecting && window.innerWidth <= 620);
    }, { threshold: 0.02 });
    observer.observe(buyArea);
  }

  refreshTotals();
})();



